// 组件对象，大写
import cellStatus from './cellStatus.vue'
export default cellStatus
